import Modal from "../Modal";
import { useState } from "react";
import { PartnerApi } from "../../../api/partner.api";
import InvoiceCanvas from "../../Invoice/InvoiceCanvas";
import { useTranslation } from "../../../hooks/useTranslation";

export default function InvoiceDetailModal({
  show,
    handleClose,
  invoice_id,
  token,
  title = null,
}) {
  const { t } = useTranslation();
  const defaultTitle = t("invoices.preview");
  const [buttons, setButtons] = useState(null);
  return (
    <Modal
      title={title || defaultTitle}
      show={show}
      handleClose={handleClose}
      buttons={
        <>
          <a
            href="#"
            onClick={() =>
              PartnerApi.download(
                "/invoice/" + invoice_id + "/download.pdf",
                "faktura_" + invoice_id + ".pdf",
                token
              )
            }
            className="btn btn-light-primary me-3"
          >
            {t("common.download")} PDF
          </a>
          <a
            href="#"
            onClick={() =>
              PartnerApi.download(
                "/invoice/" + invoice_id + "/download.isdoc",
                "faktura_" + invoice_id + ".isdoc",
                token
              )
            }
            className="btn btn-light-primary me-3"
          >
            {t("common.download")} ISDOC
          </a>
        </>
      }
      width="800px"
    >
      {invoice_id && <InvoiceCanvas invoice_id={invoice_id} token={token} />}
      {/*invoice_id && (
        <a
          href={async () =>
            await PartnerApi.download(
              "/invoice/" + invoice_id + "/download.pdf",
              false,
              token
            )
          }
        >
          PDF
        </a>
      )*/}
    </Modal>
  );
}
